import React from 'react'
import { StyledFormErrorMessage } from './styled'
import { FormErrorMessageProps } from './types'

export const FormErrorMessage: React.FC<FormErrorMessageProps> = props => {
  return <StyledFormErrorMessage {...props} />
}
